import { useState } from "react";
import { useNavigate } from "react-router-dom";

// View type state - unified key with DashboardManager
export const useViewType = (profile) => {
  const navigate = useNavigate();

  const [viewType, setViewType] = useState(() => {
    const savedViewType = localStorage.getItem("managerViewType");
    return savedViewType || "user";
  });

  const hasAdminLevel = () => {
    try {
      const adminLevelData = localStorage.getItem("adminLevel");
      if (adminLevelData) {
        const adminLevel = JSON.parse(adminLevelData);
        return adminLevel && (adminLevel.modules?.length > 0 || adminLevel.adminLevelId);
      }
    } catch (error) {
      console.error("Error checking admin level:", error);
      return false;
    }
    return false;
  };

  const handleViewTypeChange = (type) => {
    setViewType(type);

    // Navigation logic based on view type
    if (type === "user") {
      // If user has admin role or admin level, go to userprofileadmin, otherwise stay in userprofilemanager
      if ((profile?.role || localStorage.getItem("role")) === "admin" || hasAdminLevel()) {
        navigate("/userprofileadmin/professionalProfile");
      } else {
        navigate("../userprofilemanager/professionalProfile");
      }
    } else if (type === "manager") {
      navigate("/DashboardManager/dashboard");
    } else if (type === "admin") {
      // If user has admin role, go to userprofileadmin, otherwise go to dashboard
      if ((profile?.role || localStorage.getItem("role")) === "admin" || hasAdminLevel()) {
        navigate("/userprofileadmin/professionalProfile");
      } else {
        // "/dashboard" alone lands the shell with no page segment selected —
        // target the actual "dashboard" page, matching how every other
        // "go to admin dashboard" navigation in the app does it.
        navigate("/dashboard/dashboard");
      }
    }
  };

  return { viewType, handleViewTypeChange, hasAdminLevel };
};
